/** Default max total attachment payload for outgoing email and email templates (25 MiB). */
export const OUTGOING_EMAIL_MAX_ATTACHMENT_BYTES = 25 * 1024 * 1024

/** Max total attachment payload for SendGrid (SPF) outgoing email (20 MiB). */
export const SENDGRID_OUTGOING_EMAIL_MAX_ATTACHMENT_BYTES = 20 * 1024 * 1024

const SENDGRID_MAILBOX_TYPE = 'MAILBOX_TYPE_SPF'

export const isSendGridMailboxType = (mailboxType?: string | null) =>
  mailboxType === SENDGRID_MAILBOX_TYPE

export const getOutgoingEmailMaxAttachmentBytes = (mailboxType?: string | null) =>
  isSendGridMailboxType(mailboxType)
    ? SENDGRID_OUTGOING_EMAIL_MAX_ATTACHMENT_BYTES
    : OUTGOING_EMAIL_MAX_ATTACHMENT_BYTES

export const exceedsOutgoingEmailAttachmentLimit = (
  total: number,
  incoming = 0,
  mailboxType?: string | null
) => {
  const maxBytes = getOutgoingEmailMaxAttachmentBytes(mailboxType)
  return incoming > maxBytes || total + incoming > maxBytes
}

export const outgoingEmailAttachmentLimitI18nKey = (mailboxType?: string | null) =>
  isSendGridMailboxType(mailboxType)
    ? 'message.uploadingErrors.maxTotalFilesSize20MB'
    : 'message.uploadingErrors.maxTotalFilesSize25MB'
